// Footer.js
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import '../CSS/Components/HeadLogo.css'; // Import the CSS file

// Import images from the src folder
import WhteYusefIcon from '../Images/YusefLogoIconWhte.svg';
import BlkYusefIcon from '../Images/YusefLogoIconBlk.svg';
import WhteYusefText from '../Images/YusefLogoTextWhte.svg';
import BlkYusefText from '../Images/YusefLogoTextBlk.svg';

function HeadLogo({ currentSection, itemSection, isMobile, isHidden = false, isTransparent = false, onHomeClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  const safeCurrentSection = currentSection || "video3";
  const shouldShowText = safeCurrentSection === "video1";
  const shouldShowIcon = currentSection !== "store" && itemSection !== "about";

  const handleHomeClick = (event) => {
    event.preventDefault();

    if (isHidden) {
      return;
    }

    if (location.pathname !== "/") {
      navigate("/");
    }

    onHomeClick?.();

    const homeSection = document.getElementById("home");

    if (homeSection) {
      homeSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

const isLightSection =
  isMobile === true ||
  safeCurrentSection === "video0" ||
  safeCurrentSection === "video1" ||
  safeCurrentSection === "video2" ||
  safeCurrentSection === "video3" ||
  safeCurrentSection === "video4" ||
  safeCurrentSection === "home" ||
  itemSection === "services" ||
  itemSection === "vision" ||
  itemSection === "store" ||
  itemSection === "about";

const textSrc = isLightSection ? WhteYusefText : BlkYusefText;
const iconSrc = isLightSection ? WhteYusefIcon : BlkYusefIcon;
      
  return (
    <div>
      <div 
        className={`homeLogo ${isHidden ? 'is-hidden' : ''} ${isTransparent ? 'is-transparent' : ''}`.trim()}
        aria-hidden={isHidden}
        // style={{
        //   justifyContent: iconCentered ? "center" : "flex-start", // Dynamically align icon
        // }}
      >
        <a
          className="yusefLogo"
          href="/"
          tabIndex={isHidden ? -1 : 0}
          onClick={handleHomeClick}
        >
          <span className="homeLogo__mark">
            <img
              src={textSrc}
              alt="YusefText"
              className={`yusefText ${shouldShowText ? 'is-visible' : ''}`.trim()}
            />
            <img
              src={iconSrc}
              alt="YusefLogo"
              className={`yusefIcon ${shouldShowIcon ? 'visible' : ''} ${shouldShowText ? 'is-text-visible' : 'is-text-hidden'}`.trim()}
            />
          </span>
        </a>
      </div>
    </div>
  );
}

export default HeadLogo;


